module.exports = __webpack_public_path__ + "static/media/fly0216.69dbbcdf.webp";